<template>
  <div class="page--list d-flex justify-center align-center">
    <v-container fluid>
      <v-form ref="form">
        <v-row justify="center">
          <v-col cols="12" md="8" lg="6">
            <v-card class="mb-4">
              <v-container fluid>
                <v-row justify="center">
                  <v-col cols="12" class="text-center">
                    <h1 class="primary--text page-title">
                      Dados do Profissional
                    </h1>
                  </v-col>
                </v-row>
              </v-container>
              <v-divider></v-divider>
              <section>
                <v-subheader inset class="ml-0 mt-3">
                  <strong>Dados Pessoais</strong>
                </v-subheader>
                <v-row class="px-3">
                  <v-col cols="12" md="8">
                    <v-text-field
                      id="nome"
                      label="Nome*"
                      v-model="form.nome"
                      dense
                      outlined
                      hide-details="auto"
                      maxlength="100"
                      :rules="[(v) => $required(v)]"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      id="cpf"
                      label="CPF*"
                      v-model="form.cpf"
                      v-mask="'###.###.###-##'"
                      dense
                      outlined
                      hide-details="auto"
                      maxlength="14"
                      :rules="[(v) => $required(v)]"
                    />
                  </v-col>
                </v-row>
                <v-row class="px-3">
                  <v-col cols="12" md="8">
                    <v-text-field
                      id="email"
                      label="E-mail*"
                      v-model="form.email"
                      dense
                      outlined
                      hide-details="auto"
                      maxlength="100"
                      :rules="[(v) => $required(v)]"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      id="telefone"
                      label="Telefone para contato*"
                      v-model="form.telefone"
                      v-mask="'(##) #####-####'"
                      dense
                      outlined
                      hide-details="auto"
                      maxlength="16"
                      :rules="[(v) => $required(v)]"
                    />
                  </v-col>
                </v-row>
                <v-row class="px-3 mb-3">
                  <v-col cols="12" class="d-flex">
                    <p class="my-2 mr-2">Possui nome social?</p>
                    <v-switch
                      v-model="temNomeSocial"
                      hide-details
                      class="my-2 pa-0"
                      :label="temNomeSocial ? 'Sim' : 'Não'"
                    ></v-switch>
                  </v-col>
                  <v-col cols="12" md="8" v-if="temNomeSocial">
                    <v-text-field
                      label="Nome Social*"
                      v-model="form.nomeSocial"
                      dense
                      outlined
                      hide-details="auto"
                      maxlength="100"
                      :rules="[(v) => $required(v)]"
                    />
                  </v-col>
                </v-row>
              </section>
              <v-divider></v-divider>
              <section>
                <v-subheader inset class="ml-0 mt-7">
                  <strong>Formação Profissional</strong>
                </v-subheader>
                <v-row class="px-3">
                  <v-col cols="12" md="6">
                    <v-autocomplete
                      id="grauEscolaridade"
                      label="Grau de Escolaridade*"
                      :items="$opcoesGrauEscolaridade"
                      :item-text="'descricao'"
                      :item-value="'value'"
                      v-model="form.grauEscolaridade"
                      hide-details="auto"
                      outlined
                      dense
                      :rules="[(v) => $required(v)]"
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-autocomplete
                      id="funcaoPrograma"
                      label="Função no Programa*"
                      :items="lists.listaFuncaoPrograma"
                      :item-text="'nome'"
                      :item-value="'id'"
                      v-model="form.funcaoPrograma"
                      outlined
                      hide-details="auto"
                      dense
                      :rules="[(v) => $required(v)]"
                    />
                  </v-col>
                </v-row>
                <v-row class="px-3">
                  <v-col cols="12" md="6">
                    <v-autocomplete
                      id="municipioFormacao"
                      label="Município*"
                      :items="lists.listaMunicipioFormacao"
                      :item-text="'nome'"
                      :item-value="'id'"
                      hide-details="auto"
                      v-model="form.municipioFormacao"
                      @change="filtrarLotacoesPorMunicipio"
                      outlined
                      dense
                      return-object
                      :rules="[(v) => v && v.id ? true : 'Campo obrigatório']"
                      />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-autocomplete
                      id="localLotacao"
                      label="Local de Lotação*"
                      :items="lists.listaLocalLotacao"
                      :item-text="'nome'"
                      :item-value="'id'"
                      v-model="form.localLotacao"
                      hide-details="auto"
                      outlined
                      dense
                      :rules="[(v) => $required(v), lotacoesValidas]"
                      />
                  </v-col>
                </v-row>
                <v-row class="px-3">
                  <v-col cols="12" class="d-flex">
                    <p class="my-2 mr-2">Possui outro local de lotação?</p>
                    <v-switch
                      v-model="temLotacaoSecundaria"
                      hide-details
                      class="my-2"
                      :label="temLotacaoSecundaria ? 'Sim' : 'Não'"
                    ></v-switch>
                  </v-col>
                </v-row>
                <v-row class="px-3 mb-3" v-if="temLotacaoSecundaria">
                  <v-col cols="12" md="6">
                    <v-autocomplete
                      id="municipioFormacaoSecundario"
                      label="Município*"
                      :items="lists.listaMunicipioFormacao"
                      :item-text="'nome'"
                      :item-value="'id'"
                      hide-details="auto"
                      v-model="form.municipioFormacaoSecundario"
                      @change="filtrarLotacoesSecundariasPorMunicipio"
                      outlined
                      dense
                      return-object
                      :key="lotacaoSecundariaKey"
                      :rules="[(v) => v && v.id ? true : 'Campo obrigatório']"
                      />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-autocomplete
                      id="localLotacaoSecundario"
                      label="Local de Lotação*"
                      :disabled="!form.municipioFormacaoSecundario"
                      :items="lists.listaLocalLotacaoSecundaria"
                      :item-text="'nome'"
                      :item-value="'id'"
                      v-model="form.lotacaoSecundaria"
                      hide-details="auto"
                      outlined
                      dense
                      :rules="[(v) => $required(v), lotacoesValidas]"
                      />
                  </v-col>
                </v-row>
              </section>
              <v-divider></v-divider>
              <section>
                <v-subheader inset class="ml-0 mt-7">
                  <strong>Endereço Residencial</strong>
                </v-subheader>
                <v-row class="px-3">
                  <v-col cols="12" md="4">
                    <v-text-field
                      id="cep"
                      label="CEP*"
                      v-model="form.cep"
                      v-mask="'##.###-###'"
                      dense
                      outlined
                      hide-details="auto"
                      @blur="buscarEnderecoPorCep"
                      maxlength="10"
                      counter="10"
                      :rules="[(v) => $required(v)]"
                    />
                  </v-col>
                  <v-col cols="12" md="8">
                    <v-text-field
                      id="logradouro"
                      label="Logradouro*"
                      v-model="form.logradouro"
                      dense
                      outlined
                      hide-details="auto"
                      maxlength="100"
                      counter="100"
                      :rules="[(v) => $required(v)]"
                    />
                  </v-col>
                </v-row>
                <v-row class="px-3">
                  <v-col cols="12" md="5">
                    <v-text-field
                      id="bairro"
                      label="Bairro*"
                      v-model="form.bairro"
                      dense
                      outlined
                      hide-details="auto"
                      maxlength="100"
                      counter="100"
                      :rules="[(v) => $required(v)]"
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-autocomplete
                      id="uf"
                      label="UF*"
                      :items="$opcoesUFS"
                      :item-text="'value'"
                      :item-value="'value'"
                      v-model="form.uf"
                      @change="filtrarMunicipioPorUF"
                      dense
                      outlined
                      hide-details="auto"
                      :rules="[(v) => $required(v)]"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-autocomplete
                      id="municipioEndereco"
                      label="Município*"
                      :items="lists.listaMunicipioEndereco"
                      :item-text="'nome'"
                      :item-value="'nome'"
                      v-model="form.municipio"
                      outlined
                      dense
                      :rules="[(v) => $required(v)]"
                    />
                  </v-col>
                </v-row>
                <v-row class="px-3">
                  <v-col cols="12" md="3">
                    <v-text-field
                      id="numero"
                      label="Número*"
                      v-model="form.numero"
                      dense
                      outlined
                      hide-details="auto"
                      maxlength="10"
                      :rules="[(v) => $required(v)]"
                    />
                  </v-col>
                  <v-col cols="12" md="9">
                    <v-text-field
                      id="complemento"
                      label="Complemento"
                      v-model="form.complemento"
                      dense
                      outlined
                      hide-details="auto"
                      maxlength="100"
                    />
                  </v-col>
                </v-row>
              </section>

              <div class="alert-message d-flex align-center mt-4">
                <v-icon color="warning" class="mr-2">mdi-alert-circle</v-icon>
                <span>Os campos marcados com asterisco(*) são obrigatórios</span>
              </div>

              <v-row class="py-4 pr-2 mt-7" justify="center">
                <v-btn color="primary" class="mr-4" @click="salvar">Salvar</v-btn>
                <v-btn @click="$router.push('/Login')" dark color="primary" outlined class="mr-4">
                  Cancelar
                </v-btn>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import PreLoginService from "~/services/pre-login.service";

export default {
  name: 'CadastroPedagogico',
  mixins: [PreLoginService],
  data() {
    return {
      temNomeSocial: false,
      temLotacaoSecundaria: false,
      lotacaoSecundariaKey: 0,
      form: {
        cpf: null,
        nome: null,
        nomeSocial: null,
        email: null,
        telefone: null,
        ddd: null,
        grauEscolaridade: null,
        funcaoPrograma: null,
        localLotacao: null,
        lotacaoSecundaria: null,
        municipioFormacao: null,
        municipioFormacaoSecundario: null,
        cep: null,
        logradouro: null,
        bairro: null,
        uf: null,
        municipio: null,
        numero: null,
        complemento: null,
      },
      lists: {
        listaFuncaoPrograma: [],
        listaLocalLotacao: [],
        listaLocalLotacaoSecundaria: [],
        listaMunicipioFormacao: [],
        listaMunicipioEndereco: [],
        listaUF: []
      },
    };
  },
  computed: {
    lotacoesIguais() {
      return this.form.localLotacao === this.form.lotacaoSecundaria;
    }
  },
  watch: {
    temNomeSocial: function (newValue) {
      if (!newValue) {
        this.form.nomeSocial = null;
      }
    },
    temLotacaoSecundaria: function (newValue) {
      if (!newValue) {
        this.form.municipioFormacaoSecundario = null;
        this.form.lotacaoSecundaria = null;
        this.lists.listaLocalLotacaoSecundaria = [];
      }
    },
  },
  methods: {
    salvar() {
      const save = () => {
        return this.$swal({
          text: "Deseja enviar a solicitação de acesso ao Sistema Criança Alfabetizada?",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
        }).then(() => {
          this.desmascararCampos();
          const cadastroPedagogicoPayload = this.construirCadastroPedagogicoPayload();
          return this.$cadastrarCadastroPedagogico(cadastroPedagogicoPayload);
        });
      };
      if (this.lotacoesIguais) {
        this.$notifyError("O mesmo local de lotação foi selecionado nas duas opções. É necessário escolher locais distintos.");
        return;
      }

      if (this.$validarFormulario("Todos os campos obrigatórios devem ser preenchidos.")) {
        save().then(({ data }) => {
          this.$swal({
            text: "Os dados foram enviados para avaliação da gestão do programa. Você será comunicado no e-mail informado.",
            type: "success",
            confirmButtonText: "Ok",
          }).then(() => {
            this.$notifySuccess(data.mensagem);
            this.$router.push({ name: "Login" });
          });
        });
      }
    },

    lotacoesValidas() {
      return this.lotacoesIguais
       ? "Os locais de lotação não podem ser iguais."
       : true;
    },

    desmascararCampos() {
      this.form.cpf = this.form.cpf.replace(/\D/g, '');
      this.form.telefone = this.form.telefone.replace(/\D/g, '');
      this.form.cep = this.form.cep.replace(/\D/g, '');
      this.form.ddd = this.form.telefone.substring(0, 2);
      this.form.telefone = this.form.telefone.substring(2);
    },

    construirCadastroPedagogicoPayload() {
      const { municipio, uf, ...restoDoFormulario } = this.form;
      return {
        ...restoDoFormulario,
        municipio: municipio,
        uf: uf,
        municipioFormacao: this.form.municipioFormacao.id,
      };
    },

    filtrarLotacoesPorMunicipio() {
      this.form.localLotacao = null;
      const params = {
        codigoMunicipio: this.form.municipioFormacao.codigoMunicipio
      };
      this.$obterLotacoes({ params }).then(({ data }) => {
        this.lists.listaLocalLotacao = data.lista;
      }).finally(() => {
        this.hidePageLoading();
      });
    },

    filtrarLotacoesSecundariasPorMunicipio() {
      this.form.lotacaoSecundaria = null;
      const params = {
        codigoMunicipio: this.form.municipioFormacaoSecundario.codigoMunicipio
      };
      this.$obterLotacoes({ params }).then(({ data }) => {
          this.lotacaoSecundariaKey++;
          this.lists.listaLocalLotacaoSecundaria = data.lista;
      }).finally(() => {
        this.hidePageLoading();
      });
    },

    filtrarMunicipioPorUF() {
      const params = {
        uf: this.form.uf
      };
      this.$obterMunicipiosSiepe({ params }).then(({ data }) => {
        this.lists.listaMunicipioEndereco = data.lista;
      });
    },

    validarCep() {
      const cepSemMascara = this.form.cep?.replace(/\D/g, "");
      return cepSemMascara?.length === 8;
    },

    buscarEnderecoPorCep() {
      const cepSemMascara = this.form.cep?.replace(/\D/g, "");
      if (!this.validarCep()) {
        this.$notifyError("Formato do CEP inválido. Verifique os dados inseridos e tente novamente.");
        return;
      }
      this.$obterCEP({ params: { cep: cepSemMascara } })
        .then((response) => {
          const endereco = response.data.endereco;

          if (!response.data.sucesso || !(endereco?.cep && endereco?.logradouro && endereco?.bairro && endereco?.municipio.nome && endereco?.uf.nome)) {
            this.$notifyError("Não encontramos o CEP informado. Por favor, preencha os campos de endereço manualmente.");
            this.limparCamposEndereco();
            return;
          }
          this.preencherEndereco(endereco);
        })
        .catch(() => {
        this.$notifyWarning("Não encontramos o CEP informado. Por favor, preencha os campos de endereço manualmente.");
        this.limparCamposEndereco();
      });
    },

    preencherEndereco({ cep, logradouro, bairro, municipio, uf }) {
      this.form = {
        ...this.form,
        cep: this.$formatarCep(cep),
        logradouro,
        bairro,
        municipio: municipio.nome,
        uf: uf.nome,
      };
      this.filtrarMunicipioPorUF();
    },

    limparCamposEndereco() {
      this.form = {
        ...this.form,
        logradouro: '',
        bairro: '',
        municipio: '',
        uf: '',
      };
    },
  },
  mounted() {
    this.$obterFuncoes().then(({ data }) => {
      this.lists.listaFuncaoPrograma = data.lista.filter(funcao => !funcao.servidorDoEstado)
    });

    this.$obterMunicipios().then(({ data }) => {
      this.lists.listaMunicipioFormacao = data.lista;
    });
  },
};
</script>

<style scoped>
.page--list {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.alert-message {
  background-color: #fff3cd;
  border: 1px solid #ffeeba;
  padding: 10px;
  border-radius: 4px;
}
</style>
